<template>
  <article class="episode">
    <div class="image" :style="{ backgroundImage: 'url(' + featuredImage + ')' }">
      <router-link :to="{name: 'Post', params: {slug: episode.slug}}"></router-link>
    </div>
    <div class="content">
      <router-link :to="{name: 'Post', params: {slug: episode.slug}}"><h2 v-html="episode.title"></h2></router-link>
      <p class="meta">
        <span v-if="episode.number">{{ episodeNumber }} •</span> 
        <span>{{ formattedDate }}</span>
        <span v-if="episodeTopics">• 
          <span v-for="(topic, index) in episodeTopics">
            <router-link :to="{name: 'Category', params: { topic: topic.slug }}" v-html="topic.name"></router-link><span v-if="index + 1 !== episodeTopics.length">, </span>
          </span>
        </span>
      </p>
      <p><span v-html="episode.excerpt"></span> <router-link :to="{ name: 'Post', params: { slug: episode.slug } }" class="more-link">More</router-link></p>
      <v-waypoint v-if="index === 6" @waypoint="$parent.handleScroll"></v-waypoint>
    </div>
  </article>
</template>

<script>
export default {
  name: 'episode',
  props: ['episode', 'index'],
  computed: {
    episodeNumber () {
      if (this.episode.lstplus) {
        return 'LST+'
      } else if (this.episode.number) {
        return '#' + this.episode.number
      }
    },
    formattedDate () {
      return this.$moment(this.episode.date).format('MM.DD.YY')
    },
    featuredImage () {
      let vm = this
      let image = vm.episode.image.large
      if (process.env.NODE_ENV === 'development') {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
      }
      return image
    },
    episodeTopics () {
      if (this.episode.topics) {
        return this.episode.topics.filter((topic) => {
          return topic.name !== 'PODCAST'
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  $sectionColor: $turquoise

  article.episode
    border-top: solid 8px $sectionColor
    background: #ffffff
    margin: 0 15px 30px
    +tablet
      display: flex
      margin: 0 0 34px
      padding: 28px
    h2
      font-size: 24px
      font-weight: bold
      margin-bottom: 0.15em
      +tablet
        font-size: 28px
      &:hover
        color: lighten($textColor, 25%)
    p
      +tablet
        font-size: 18px
        line-height: 28px
      &.meta
        font-weight: bold
        letter-spacing: 0.5px
        margin-bottom: 0.55em
        +tablet
          font-size: 18px
          line-height: 22px
        a
          color: inherit
          &:hover
            color: lighten($textColor, 25%)
    .image
      background: $sectionColor
      background-size: cover
      background-position: center center
      position: relative
      display: block
      width: 100%
      +until($tablet)
        height: 0
        padding-top: 56.25%
        margin-bottom: 10px
      +tablet
        margin-right: 56px
        width: 248px
        height: 148px
      a
        position: absolute
        top: 0
        left: 0
        right: 0
        bottom: 0
        &:hover
          background: rgba(255,255,255,0.10)
    .content
      flex: 1
</style>



// WEBPACK FOOTER //
// Episode.vue?bf5190be